import { ICookies } from "../interfaces/cookies.interface";
import DOMPurify from "dompurify";
import showdown from "showdown";

export const setCookie = (
    name: any,
    value: any,
    hours?: any,
    path = "/",
    domain?: any,
    secure?: any
) => {
    let cookieString = `${encodeURIComponent(name)}=${encodeURIComponent(value)}`;

    if (hours !== undefined && hours !== null) {
        const date = new Date();
        date.setTime(date.getTime() + hours * 60 * 60 * 1000);
        cookieString += `; expires=${date.toUTCString()}`;
    }

    cookieString += `; path=${path}`;

    if (domain) {
        cookieString += `; domain=${domain}`;
    }

    if (secure) {
        cookieString += `; secure`;
    }

    document.cookie = cookieString;
};

export const getCookies = (): ICookies => {
    const cookies = document.cookie;
    const cookieArray = cookies.split(";");
    const cookieObject = {};

    cookieArray.forEach((cookie) => {
        let [name, value] = cookie.split("=");
        name = name.trim();
        value = value ? value.trim() : "";
        Object.assign(cookieObject, {
            ...cookieObject,
            [name]: decodeURIComponent(value)
        });
    });

    return cookieObject;
};

export const clearCookies = (): ICookies => {
    const cookies = document.cookie;
    const cookieArray = cookies.split(";");
    const cookieObject = {};

    cookieArray.forEach((cookie) => {
        let [name] = cookie.split("=");
        name = name.trim();
        setCookie(name, null, 0);
    });

    return cookieObject;
};

const markdownConverter = new showdown.Converter({ simpleLineBreaks: true, strikethrough: true });

export const markdownToHtml = (markdown: string) => {
    return DOMPurify.sanitize(markdownConverter.makeHtml(markdown));
};

export const delay = async (time: number): Promise<void> => {
    return new Promise((resolve) => setTimeout(() => resolve(), time));
};

interface IDateParts {
    YYYY: string;
    M: string;
    MM: string;
    d: string;
    dd: string;
    HH: string;
    mm: string;
    ms: string;
    [key: string]: string;
}

export const getDateParts = (date: string | Date, locale = "pt-PT"): IDateParts => {
    let d: Date;

    if (typeof date === "string") {
        d = new Date(date);
    } else {
        d = date;
    }

    const month = d.getUTCMonth() + 1;
    const day = d.getUTCDate();
    const hour = d.getUTCHours();
    const minutes = d.getUTCMinutes();
    const seconds = d.getUTCSeconds();
    const milliseconds = d.getUTCMilliseconds();

    return {
        YYYY: `${d.getFullYear()}`,
        dd: day < 10 ? `0${day}` : `${day}`,
        d: `${day}`,
        HH: hour < 10 ? `0${hour}` : `${hour}`,
        mm: minutes < 10 ? `0${minutes}` : `${minutes}`,
        ss: seconds < 10 ? `0${seconds}` : `${seconds}`,
        ms: milliseconds < 10 ? `0${milliseconds}` : `${milliseconds}`,
        MMMM: new Intl.DateTimeFormat(locale, { month: "long" }).format(d),
        MM: month < 10 ? `0${month}` : `${month}`,
        M: `${month}`
    };
};

export const formatDate = (date: string | Date, format: string, locale?: string) => {
    const dateParts = getDateParts(date, locale);

    let formatArray = format;
    let temp: any = [];

    Object.keys(dateParts).forEach((k) => {

        const index = formatArray.indexOf(k);
        const value = dateParts[k];
        if (index < 0) return;
        temp.push(value);

        formatArray = formatArray.replaceAll(k, `#${temp.length - 1}#`);
    });

    temp.forEach((val: string, index: number) => { formatArray = formatArray.replaceAll(`#${index}#`, val) });

    return formatArray;
};

export const secondsToTimeFormat = (sec: number) => {
    return `${Math.floor(sec / 60) < 10 ? "0" + Math.floor(sec / 60) : Math.floor(sec / 60)}:${Math.floor(sec % 60) < 10 ? "0" + Math.floor(sec % 60) : Math.floor(sec % 60)}`;
};

export const getFormattedPath = (template: string, values: any) => {
    return template.replace(/:([a-zA-Z0-9_]+)/g, (match, key) => {
        return values[key] || match;
    });
};

export const handleFileDownload = async (url: string, name?: string) => {
    const response = await fetch(url);
    const blob = await response.blob();
    const file_url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = file_url;
    a.download = name ?? "";
    document.body.appendChild(a);
    a.click();
    a.remove();
};

export const formatTemplate = (template: string, values: string[]) => {
    return template.replace(/\{(\d+)\}/g, (match, index) => {
        return typeof values[index] !== "undefined" ? values[index] : match;
    });
};
